import React, { useEffect, useState } from 'react'
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import { IndeterminateCheckbox } from 'components/tables/tableTools'
import ZeusTable2 from 'components/tables/ZeusTable2.tsx'

import { createColumnHelper } from '@tanstack/react-table'

export default function ConnectedUnits(props) {
    
    const API = axios.create({
        baseURL: process.env.REACT_APP_BASE_URL,
        withCredentials: true,
    });

    // Table data
    const [data, setData] = useState({})
    const [rowSelection, setRowSelection] = useState([])
    const [units, setUnits] = useState([])

    async function getUnits() {
        try {
            const allUnits = await API.post("/admin/units/all");
            setData(allUnits.data);
            console.log(allUnits.data)
            const resConnections = await API.post("/units/connected", { 'id': props.id });
            console.log(resConnections)
            const usersUnits = resConnections.data.map(u => u.unit_id)
            console.log(usersUnits)

            setUnits(usersUnits)
            const tableRowConnections = {}
            usersUnits.forEach(function (uid) {
                const i = allUnits.data.map(function (unit) { return unit.unit_id; }).indexOf(uid);
                tableRowConnections[i] = true
            })
            setRowSelection(tableRowConnections)
            console.log(tableRowConnections)
        } catch (error) {
            console.log(error?.response?.data);
            toast.error(error?.response?.data)
        }
    }
    useEffect(() => {
        getUnits();
    }, [])

    // Table construction
    const columnHelper = createColumnHelper()
    const columns = [
        columnHelper.display({
            id: 'Selection',
            header: () => <span>Selected</span>,
            cell: ({ row }) => <IndeterminateCheckbox
                {...{
                    checked: row.getIsSelected(),
                    indeterminate: row.getIsSomeSelected(),
                    onChange: row.getToggleSelectedHandler(),
                }}
            />,
        }),
        columnHelper.accessor(row => row.unit_id, {
            id: 'Unit ID',
            header: () => <span>Unit ID</span>,
            cell: info => info.getValue(),
            footer: info => info.column.id,
        }),
        columnHelper.accessor(row => row.name, {
            id: 'Unit Name',
            header: () => <span>Unit Name</span>,
            cell: info => info.getValue(),
            footer: info => info.column.id,
        })
    ]

    useEffect(() => {
        const unitSelection = []
        for (let i = 0; i < Object.keys(data).length; i++) {
            if (rowSelection[i] === true) {
                unitSelection.push(data[i].unit_id)
            }
        }
        setUnits(unitSelection)
    }, [rowSelection])

    const closeForm = () => {
        toast.error("Selection changes discarded")
        props.closeForm()
    }

    const saveChanges = () => {
        const data = {
            user_id: props.id,
            units: units
        }
        API.post("/units/connected/update", data )
        .then(response => {
          toast.success("Unit selection saved")
          props.saveChanges();
        })
        .catch(error => {
          console.log("error:", error.response.data)
          toast.error(error.response.data)
        });
    }



    return (
        <div>
            <div id="Unis" className={`modal fade ${true ? 'show' : ''}`} tabIndex="-1" role="dialog" style={{ paddingRight: 5 + 'px' }} aria-modal="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button  onClick={() => closeForm()} type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span>
                            </button>
                            <h4 className="modal-title" data-locale="Units">Units</h4>
                        </div>
                        <div className="modal-body">

                            <ZeusTable2
                                columns={columns}
                                data={data}
                                rowSelection={rowSelection}
                                setRowSelection={setRowSelection}
                                refreshData={getUnits}
                            />

                        </div>
                        <div className="form-group row">
                                <div className="col-sm-10" style={{textAlign: 'right'}}>
                                    <button onClick={() => closeForm()} type="button" className="btn btn-default" data-dismiss="modal" data-locale="close">
                                        Close
                                    </button>
                                    <button onClick={() => saveChanges()} type="button" className="btn btn-primary save" data-locale="save">
                                        Save
                                    </button>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}